import React, { useCallback, useState } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import GroupedCarrierPackageDropdown from '../../../../../../../../components/grouped-carrier-package-dropdown';
import GroupedCarrierServiceDropdown from '../../../../../../../../components/grouped-carrier-service-dropdown';
import Global from '../../../../../../../../store/global-selectors';
import { PARAMETER } from '../../../../../constants/parameter-name-for-update';
import InputValueProps from '../../../../../prop-types/input-value-props';
import messages from './messages';
import style from './style.module.less';
import UnexpectedValueComponent from './unexpected-value';

const SetCarrierServicePackage = ({ className, inputValueProps, onChange }) => {
  const { parameter } = inputValueProps;
  const isNewAction = parameter === undefined;
  const valueParts = parameter?.toString().split(',') || [];
  const [labelProviderId, setLabelProviderId] = useState(valueParts[0]);
  const [serviceId, setServiceId] = useState(valueParts[1]);
  const [packageId, setPackageId] = useState(valueParts[2]);

  const services = useSelector(Global.selectSellerExtendedServices);
  const service = services.find((prov) => prov.serviceId === serviceId);
  const [carrierId, setCarrierId] = useState(service?.carrierId);

  const valueDoesNotConformToStandard = !isNewAction && valueParts.length !== 3;
  const onSetService = useCallback(
    ({ carrierId: _carrierId, serviceId: _serviceId, labelProviderId: _labelProviderId }) => {
      setCarrierId(_carrierId);
      setServiceId(_serviceId);
      setLabelProviderId(_labelProviderId);
      onChange({
        [PARAMETER]: `${_labelProviderId},${_serviceId},${packageId}`,
      });
    },
    [onChange, packageId],
  );
  const onSetPackageId = useCallback(
    (packId) => {
      const isCustomPackage = packId?.indexOf('-') >= 0;
      const parsedPackageId = isCustomPackage ? packId.substring(0, packId.indexOf('-')) : packId;
      setPackageId(parsedPackageId);
      onChange({
        [PARAMETER]: `${labelProviderId},${serviceId},${parsedPackageId}`,
      });
    },
    [onChange, serviceId, labelProviderId],
  );

  if (valueDoesNotConformToStandard) {
    return <UnexpectedValueComponent />;
  }
  return (
    <div className={classnames(style['multi-control'], className)}>
      <div className={style['multi-control-row']}>
        <div>
          <FormattedMessage {...messages.serviceLabel} />
        </div>
        <GroupedCarrierServiceDropdown
          onChange={onSetService}
          selectedCarrierId={carrierId}
          selectedLabelProviderId={labelProviderId}
          selectedServiceId={serviceId}
        />
      </div>
      <div className={classnames(style.stacked, style['multi-control-row'])}>
        <div>
          <FormattedMessage {...messages.packageLabel} />
        </div>
        <GroupedCarrierPackageDropdown carrierId={carrierId} onChange={onSetPackageId} selectedPackageId={packageId} />
      </div>
    </div>
  );
};

SetCarrierServicePackage.propTypes = {
  className: PropTypes.string,
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SetCarrierServicePackage;
